import { Routes } from '@angular/router';

import { CMS_PERMISSIONS } from '../../core/constants/permissions';
import { permissionGuard } from '../../core/guards/permission.guard';

export const analyticsRoutes: Routes = [
  {
    path: 'analiticas',
    canActivate: [permissionGuard],
    data: {
      permission: CMS_PERMISSIONS.analytics.viewAny,
    },
    loadComponent: () => import('./pages/dashboard/dashboard').then((m) => m.AnalyticsDashboard),
  },
];
